import { useEffect, useState } from "react";
import loginVisual from "../assets/login-visual.gif";

export default function AuthRightPanelImage() {
    const [showGraphic, setShowGraphic] = useState(false);

    useEffect(() => {
        function update() {
            setShowGraphic(window.innerWidth >= 768);
        }
        update();
        window.addEventListener("resize", update);
        return () => window.removeEventListener("resize", update);
    }, []);

    return (
        showGraphic && (
            <div className="hidden md:flex w-1/2 items-center justify-center">
                <img src={loginVisual} alt="Login Visual" className="" />
            </div>
        )
    );
}
